import PaymentDetailsContainer from "../../Componant/Ecommerce/PaymentDetails";

const PaymentDetails = () => {
  return (
    <div className="page-body">
      <PaymentDetailsContainer />
    </div>
  );
};

export default PaymentDetails;
